import React, { Component } from 'react'
import intl from 'react-intl-universal'
import AuthorisationHandler from '../components/AuthorisationHandler'
import ResultsInnerExperience from '../components/ResultsInnerExperience'
import Loading from '../components/Loading'
import Page from './Page'
import ProfileMenu from '../components/ProfileMenu'
import shortid from 'shortid'
import { experience } from '../api'
import { computed, observable } from 'mobx'
import { inject, observer, action, PropTypes } from 'mobx-react/index'
import object_value from '../api/object_value'
import moment from 'moment/moment'
import 'moment-timezone'

@inject('wishlist', 'user')
@observer
class ProfileMyWishlistPage extends Component {
  constructor (props) {
    super(props)

    this.state = {
      error: null,
      data: []
    }
  }

  componentDidMount() {
    const {user, wishlist} = this.props
    const {token} = user
    console.log('ProfileMyWishlistPage.js - this.props:', this.props)

    if (!token) {
      return false
    }

    wishlist.get(token)
  }

  render () {
    const {user, wishlist} = this.props
    let experiences = wishlist.data.experiences

    function format_date () {
      let date = object_value(experience, 'events.0.date')

      if (!date) {
        return false
      }

      return moment(date).utc()/*.tz('Europe/Berlin')*/.isSame(moment(), 'day')
        ? moment(date).utc()/*.tz('Europe/Berlin')*/.format('[Today - ]HH:mm')
        : moment(date).utc()/*.tz('Europe/Berlin')*/.format('DD.MM.YYYY - HH:mm')
    }

    let used = {
      today: false,
      next: false,
      passed: false
    }

    if (typeof experiences !== 'undefined' && Array.isArray(experiences) && experiences.length > 0) {
      experiences = experiences.map(experience => {
        let date = object_value(experience, 'events.0.date')
        if (date) {
          experience.computed_date = new Date(date)
        }
        return experience
      })

      experiences.sort(function(a,b){
        if (typeof a.computed_date !== 'undefined' && typeof b.computed_date !== 'undefined') {
          return a.computed_date.getTime() - b.computed_date.getTime()
        }
      });
    }

    return (
      <AuthorisationHandler>
        <Page title='My wishlist'>
          <section className='b-profile'>
            <div className='b-profile-inner'>

              <ProfileMenu />

              <div className='b-profile-main'>
                <h3 className='b-profile-title'>{intl.get('Wishlist')}</h3>

                {!wishlist.loaded
                  ? <div><Loading /></div>
                  : <div className='b-profile-experiences'>
                      <div className='b-profile-experiences-group'>
                        <div className='b-profile-experiences-group-items'>
                          {Array.isArray(experiences) && experiences.length > 0
                            ? experiences.map((experience, index) =>
                            <ResultsInnerExperience experience={experience}
                                                    key={shortid.generate()}
                                                    variant={experience.variant}
                                                    topic={experience.topic}
                                                    show_liked={true}
                                                    show_price={false}
                                                    show_table={true}
                                                    show_rating={false}
                                                    show_date={false}
                                                    show_guests={false}
                                                    show_user={true} />)
                          : <div className='b-empty'><div className='b-empty-text'>{intl.get('Keine Erlebnisse')}</div></div>}
                        </div>
                      </div>
                    </div>}
              </div>
            </div>
          </section>
        </Page>
      </AuthorisationHandler>
    )
  }
}

ProfileMyWishlistPage.propTypes = {
  user: PropTypes.observableObject,
  wishlist: PropTypes.observableObject
}

export default ProfileMyWishlistPage



// WEBPACK FOOTER //
// ./src/containers/ProfileMyWishlistPage.js